import * as React from 'react';

// Context
import { MetricsReportContext } from '../context';

// Constants
import { METRICS_EVENT_METADATA } from '../constants';

export function useMetricsReport() {
  const { reportEvents } = React.useContext(MetricsReportContext);

  const reportMetric = ({ event_type }: { event_type: string }) => {
    return reportEvents([
      {
        ...METRICS_EVENT_METADATA,
        event_type,
      },
    ]);
  };

  return {
    reportMetric,
  };
}
